module.exports = __webpack_public_path__ + "img/panang_greens.cb270975.jpg";